<template>
  <div class="caseIndex">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "CaseIndex"
};
</script>
<style lang="scss" scoped>
.caseIndex {
  height: 100%;
}
</style>
